module.exports = __webpack_public_path__ + "static/img/18.7037f2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/T恤/18.png
// module id = 7GHG
// module chunks = 0